var React = require('react');

function IconCaretDown (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"#031929","strokeWidth":"2","points":"-1.55,4.15 4.15,9.85 9.85,4.15 "}));
}

IconCaretDown.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"12.814px","height":"7.821px","viewBox":"-2.257 3.443 12.814 7.821","enableBackground":"new -2.257 3.443 12.814 7.821","xmlSpace":"preserve"};

module.exports = IconCaretDown;

IconCaretDown.default = IconCaretDown;
